var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-switch',{attrs:{"disabled":_vm.disabled},on:{"on-change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('span',{attrs:{"slot":"open"},slot:"open"},[_vm._v("是")]),_vm._v(" "),_c('span',{attrs:{"slot":"close"},slot:"close"},[_vm._v("否")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03178c9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/iSwitchLy.vue
// module id = null
// module chunks = 